import React, { useState, useRef, useEffect } from "react";
import { Fab, TextareaAutosize, Paper } from "@material-ui/core";

import { ArrowBack } from "@material-ui/icons";
import Grid from "@mui/material/Grid";
import DynamicForm from "f1-dynamic-form-react";
import Loader from "../components/loader/loader";
import { Inventory__Data, customValidators, Inventory_Data } from "./formData";
import { format } from "date-fns";

import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useNavigate } from "react-router-dom";
import { getAllOfTable } from "../offlineManager/localbase";
import { metaDataConstants } from "../utils/Constants/constants-en";
import { getDateWithFormat } from "../utils/utils";
const dateFormate = "MM-dd-yyyy HH:mm:ss";
const BarcodeReader = () => {

  let dyFormRef = useRef();
  let naviagte = useNavigate();

  const [activateLoader, setActivateLoader] = useState(false);
  const [candidateDetail, setCandidateDetail] = useState(Inventory_Data);
  const [show, setShow] = useState(false);
  const [serverityStatus, setServerityStatus] = useState("");
  const [message, setMessage] = useState("");
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [createdDate, setCreatedDate] = useState( 
    getDateWithFormat(dateFormate)
  );
  const [LocationData, setLocationData] = useState([])
  const [accountData, setAccountData] = useState([])
  const [dueDateData, setDueDateData] = useState([])
  const [storageData, setStorageData] = useState([])
  const [current, setCurrent] = useState({
    inventorydate: null,
    account: null,
    location: null,
    storageArea: null,
    inventoryduedate: null,
    inventorycounted: null,
  });

  const [labelData, setLabelData] = useState({
    storageName: null,
    locationName: null
  })
  const [transactiondata, setTransactiondata] = useState({
    transactionStatusId: null,
    moduleWorkFlowRuntimeId: null,
  });
  const [inventoryCheckId, setInventoryCheckId] = useState(null)
  const [disableSubmit, setDisableSubmit] = useState(false)

  const [locationStorageId, setLocationStorageId] = useState(null)
  const [accounId, setAccountId] = useState(0)
  const [state, setState] = useState({
    defaultSort: false,
    orderBy: 3,
    activateLoader: false,
    show: false,
    serverityStatus: "",
    message: "",
    isRecord: false,

  });

  // Data type: 'boolean', 'numeric', 'date', 'datetime', 'time', 'currency'
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShow(false);
    setState({ ...state, show: false });
  };

  const getDropdownData = (optionsArr, key, label) => {
    const arr = optionsArr?.map((item) => {
      return {
        key: item[key],
        label: item[label]?.charAt(0)?.toUpperCase() + item[label]?.slice(1),
        value: item[key],
      };
    });
    arr.unshift({ key: -1, label: "Select", value: -1 });
    return arr;
  };

  useEffect(() => {
    candidateDetail[2].options = []
    candidateDetail[3].options = []
    const dateFormate = metaDataConstants.yearMonthDateFormat;
    setBreadcrumbs([
      { name: "Dashboard", url: "/home" },
      { name: "2d-Barcode Scanner" },
    ]);
    setCreatedDate(getDateWithFormat(dateFormate));
  }, []);

  useEffect(() => {
    getAccount();
  }, [])


  const getAccount = async () => {
    return new Promise((resolve, reject) => {
      getAllOfTable('AccountDetails').then((res) => {
        resolve(res[0].accountDetails)
        setAccountData([{ id: -1, label: "Select", value: -1 }, ...res[0].accountDetails])
        const data = res[0].accountDetails
        const copyFormData = [...candidateDetail];
        copyFormData[1].options = getDropdownData(
          res[0].accountDetails,
          "id",
          "accountName"
        );
        setCandidateDetail(copyFormData)
        setAccountId(data.length > 1 ? -1 : data[0]?.id)
        getLocation(data.length > 1 ? -1 : data[0]?.id)
      }).catch((err) => reject(false))
    })

  };

  const getDueDate = async (accountId, loctionid) => {
    return new Promise((resolve, reject) => {
      getAllOfTable('DueDateDetails').then((res) => {
        resolve(res[0].dueDateDetails)
        setDueDateData(res[0].dueDateDetails)
        if (loctionid != -1) {
          const data = res[0].dueDateDetails
          const resp = data?.filter(
            (ele) =>
              ele.locationId == loctionid

          );
          if (resp.length < 1) {
            setShow(true);
            setServerityStatus('error');
            setMessage(metaDataConstants.inventoryDataUnavailable);
            setDisableSubmit(true);
          }
          const latestData = resp?.sort((a, b) => (a.dueDate > b.dueDate ? -1 : 1));
          setInventoryCheckId(latestData[0]?.inventoryCheckId)
          setTransactiondata({
            ...transactiondata,
            transactionStatusId: latestData[0]?.transactionStatusId,
            moduleWorkFlowRuntimeId: latestData[0]?.moduleWorkFlowRuntimeId,
          });
          getStorage(accountId, loctionid, latestData[0])
        } else {
          getStorage(accountId, loctionid, -1)
        }
      }).catch((err) => reject(false))
    })
  };
  const getStorage = async (accountId, locationId, latestData) => {
    setActivateLoader(true)
    return new Promise((resolve, reject) => {
      getAllOfTable('StorageDetails').then((res) => {
        resolve(res[0].storageDetails)
        if (latestData != -1) {
          const storage = res[0].storageDetails?.filter(
            (ele) =>
              ele.locationId == locationId && ele.id == latestData.inventoryCheckId
          );
          setStorageData([{ storageCode: -1, label: "Select", value: -1 }, ...storage])
          const copyFormData = [...candidateDetail];
          copyFormData[3].options = getDropdownData(
            storage,
            "storageCode",
            "storageName"
          );

          setCandidateDetail(copyFormData)
          const dateFormate = metaDataConstants.yearMonthDateFormat;
          const minDate = latestData?.dueDate && getDateWithFormat(dateFormate);
          setCurrent({
            ...current, account: accountId, location: locationId, inventorydate: minDate, inventoryduedate: latestData?.dueDate?.slice(0, 10),
            inventorycounted: `${localStorage.getItem("firstName")} ${localStorage.getItem("lastName")}`, storageArea: storage.length > 1 ? -1 : storage[0]?.storageCode
          })
        } else {
          const copyFormData = [...candidateDetail];
          copyFormData[3].options = [{ key: -1, label: "Select", value: -1 }]
          setCandidateDetail(copyFormData);
          setStorageData([{ storageCode: -1, label: "Select", value: -1 }])

          const dateFormate = metaDataConstants.yearMonthDateFormat;
          const minDate = getDateWithFormat(dateFormate);
          setCurrent({
            ...current, account: accountId, location: locationId, inventorydate: minDate, inventoryduedate: '',
            inventorycounted: `${localStorage.getItem("firstName")} ${localStorage.getItem("lastName")}`, storageArea: -1
          })
        }
        setActivateLoader(false)
      }).catch((err) => {
        reject(false)
        setActivateLoader(false)
      })
    })
  };

  const getLocation = async (accountId) => {
    setActivateLoader(true)
    return new Promise((resolve, reject) => {
      getAllOfTable('LocationDetails').then((res) => {
        resolve(res[0].locationDetails)
        if (accountId != -1) {
          const loc = res[0].locationDetails?.filter(
            (ele) =>
              ele.accountId == accountId
          );
          const copyFormData = [...candidateDetail];
          copyFormData[2].options = getDropdownData(
            loc,
            "id",
            "locationName"
          );
          setCandidateDetail(copyFormData)
          setLocationData([{ id: -1, label: "Select", value: -1 }, ...loc]);
          setActivateLoader(false)
          getDueDate(accountId, loc.length > 1 ? -1 : loc[0]?.id);
        } else {
          const copyFormData = [...candidateDetail];
          copyFormData[2].options = [{ key: -1, label: "Select", value: -1 }]
          setCandidateDetail(copyFormData);
          setLocationData([{ id: -1, label: "Select", value: -1 }]);
          setActivateLoader(false)
          getDueDate(accounId, -1);
        }
      }).catch((err) => {
        reject(false)
        setActivateLoader(false)
      })
    })
  };

  const onSubmitHandler = async (model) => {
    if (model.account != null && model.account !== "") {
      delete model.errors.account
    }
    if (model.location != null && model.location !== "") {
      delete model.errors.location
    }
    if (
      (!model.isValidForm && Object.keys(model.errors).length > 0) ||
      Object.keys(model.errors).length > 0
    ) {
      return false;
    }

    setActivateLoader(true);

    const res = storageData?.filter(
      (ele) =>
        ele.storageCode == model.storageArea
    );
    const filtData = candidateDetail[3].options.find(
      (item) => item.key == model.storageArea
    );
    const filtDataLocation = candidateDetail[2].options.find(
      (item) => item.key == model.location
    );
    const data = {
      locationName: filtDataLocation.label,
      storageName: filtData.label
    }
    setLabelData({ ...labelData, storageName: filtData.label })

    setLocationStorageId(res[0]?.locationStorageId)
    localStorage.setItem("account", model.account)   // accountid will be required in next form for payload
    localStorage.setItem("inventorydate", model.inventorydate)
    localStorage.setItem("location", model.location)  // location id , storage id, inventoryduedate, labelData is required in next for for payload
    localStorage.setItem("storageArea", model.storageArea)
    localStorage.setItem("inventoryduedate", model.inventoryduedate)
    localStorage.setItem("inventorycounted", model.inventorycounted)
    localStorage.setItem("InventoryCheckId", inventoryCheckId)  // inventoryCheckId will be required in next form for payload and sorting the product
    localStorage.setItem("LocationStorageId", res[0].locationStorageId)
    localStorage.setItem("labelData", JSON.stringify(data))
    localStorage.setItem("transactionData", JSON.stringify(transactiondata))
    setActivateLoader(false);
    localStorage.setItem("isfirstvisit", 1)
    naviagte(`/product_detail`);
  };


  const onChangeHandler = async (event, key, model) => {
    setDisableSubmit(false)
    console.log(accountData)
    if (key === "account") {
      const accountId = event.target.value
      setCurrent({ ...current, account: accountId, location: "", storageArea: "" })
      setAccountId(accountId)
      const res = accountData?.filter(
        (ele) =>
          ele.id == accountId
      );

      candidateDetail[2].options = []
      candidateDetail[3].options = []
      getLocation(accountId)
    }
    if (key === "location") {
      const locationId = event.target.value
      const res = LocationData?.filter(
        (ele) =>
          ele.id == locationId
      );
      const resp = dueDateData?.filter(
        (ele) =>
          ele.locationId == res[0]?.id
      );
      const latestData = resp.sort((a, b) => (a.dueDate > b.dueDate ? -1 : 1));
      candidateDetail[3].options = []
      const copyFormData = [...candidateDetail];

      setCandidateDetail(copyFormData)
      setCurrent({ ...current, location: locationId, inventoryduedate: latestData[0]?.dueDate?.slice(0, 10), storageArea: "" })
      setInventoryCheckId(latestData[0]?.inventoryCheckId)
      setTransactiondata({
        ...transactiondata,
        transactionStatusId: latestData[0]?.transactionStatusId,
        moduleWorkFlowRuntimeId: latestData[0]?.moduleWorkFlowRuntimeId,
      });
      getStorage(accounId, locationId, resp[0])
    }
  };

  return (
    <>
      <Snackbar
        open={show}
        autoHideDuration={4000}
        onClose={() =>
          handleClose({
            vertical: "bottom",
            horizontal: "right",
          })
        }
      >
        <Alert severity={serverityStatus}>{message}</Alert>
      </Snackbar>
      <div className="container containerMainDiv">
        <div className="contentdivBg pt-0">
          <div className="divRound">

            {localStorage.getItem("permission") == "Edit" ? (
              <div>
                <div className="clearfix"></div>
                <div className="formData mt-3">
                  <Grid className="activiPad0" container columns={{ xs: 4, md: 12 }}>
                    <Grid item xs={12} md={9} className="leftCol">
                      <DynamicForm
                        onRef={(ref) => {
                          dyFormRef.current = ref;
                        }}
                        key={1}
                        className="dynamicForm"
                        title={metaDataConstants.barcodeInvDetails}
                        design="bootrstap"
                        model={candidateDetail}
                        defaultValues={current}
                        materialOutline={false}
                        customValidators={customValidators}
                        showAstersikOnRequiredFields={true}
                        onSubmit={(model) => onSubmitHandler(model)}
                        disableSubmitOnInValid={disableSubmit}
                        onChange={(event, key, model) =>
                          onChangeHandler(event, key, model)
                        }
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>
            ) : (
              <p className="permission">{metaDataConstants.noPermissionForInv}</p>
            )}
          </div>
        </div>
      </div>
      <div></div> <Loader active={activateLoader} />
    </>
  );
};
export default BarcodeReader;
